import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=c878022e&scoped=true&"
import script from "./Legends.vue?vue&type=script&lang=js&"
export * from "./Legends.vue?vue&type=script&lang=js&"
import style0 from "./Legends.vue?vue&type=style&index=0&id=c878022e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c878022e",
  null
  
)

export default component.exports